// extracted by mini-css-extract-plugin
export default {"body":"body-exL04","footer":"footer-Wb73k"};